import React from "react";
import { motion } from "framer-motion";
import { FileSearch, ScrollText, ClipboardCheck, LineChart, Scale, Cog } from "lucide-react";
import { useI18n } from "../i18n";

const ICONS = [FileSearch, ScrollText, ClipboardCheck, LineChart, Scale, Cog];

const Consultancy = () => {
  const { t } = useI18n();
  const c = t.consultancy || {};
  const cards = c.cards || [];

  return (
    <section
      id="consultancy"
      className="relative py-24 md:py-32 bg-[var(--surface)] overflow-hidden bp-overlay"
      data-testid="consultancy-section"
    >
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16"
        >
          <div className="lg:col-span-6">
            <div className="overline mb-4">{c.overline || "PROJE DANIŞMANLIKLARI"}</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-white leading-[1.05]">
              {c.title || "Yatırımdan Teslime Tam Destek"}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:pt-12">
            <p className="text-base text-[var(--text-muted)] leading-relaxed">{c.intro || ""}</p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--border)]">
          {cards.map((card, i) => {
            const Icon = ICONS[i] || Cog;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="bg-[var(--surface)] p-8 md:p-10 hover:bg-[var(--bg)] transition-colors group"
                data-testid={`consultancy-card-${i}`}
              >
                <Icon size={32} strokeWidth={1.25} className="text-[var(--silver)] mb-6 group-hover:text-white transition-colors" />
                <h3 className="font-display text-xl font-medium text-white mb-3">{card.title}</h3>
                <p className="text-sm leading-relaxed text-[var(--text-muted)]">{card.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Consultancy;
